// extracted by mini-css-extract-plugin
export var centered = "index-module--centered--hTpTs";
export var container = "index-module--container--TNfH+";